module.exports = __webpack_public_path__ + "static/media/22ESCWA16.6b2b9450.jpg";